'use client';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@venienergygroup/shared-components';
import { useCountryAndCurrency } from '@/hooks/country/useCountryAndCurrency';
import { privacyPolicyLinkMap } from '@/lib/consts/countrySpecificLinks';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { CookieManager as ReactCookieManager } from 'react-cookie-manager';
type Props = { children: React.ReactNode };

const COOKIE_CATEGORIES = { Analytics: true, Advertising: false, Social: false };

const CookieManager: FC<Props> = ({ children }) => {
  const t = useTranslations('Cookies');
  const isMobile = useIsMobile();
  const { country } = useCountryAndCurrency();

  return (
    <ReactCookieManager
      disableGeolocation
      translations={t}
      showManageButton
      privacyPolicyUrl={privacyPolicyLinkMap[country]}
      displayType={isMobile ? 'modal' : 'popup'}
      cookieCategories={COOKIE_CATEGORIES}
      classNames={{
        //? The .cookie-manager class from the library is overriding the CSS values (v4.0.0)
        //? Has to be fixed by the library maintainers
        acceptButton: cn(
          buttonVariants({
            variant: 'outline',
            className:
              '!bg-veni-green-950 hover:!bg-veni-green-950/80 !text-primary-foreground flex-1',
          }),
        ),
        declineButton: buttonVariants({ variant: 'outline', className: 'flex-1 hover:!bg-accent' }),
        manageButton: buttonVariants({ variant: 'ghost', size: 'sm' }),
        manageCookieToggle:
          'bg-gray-300 w-11 h-6 rounded-full peer peer-focus:ring-2 peer-focus:!ring-green-800 !peer-checked:bg-veni-green-950 peer-checked:after:!translate-x-[1.25rem] after:content-[""] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5  after:transition-all',
        manageCookieToggleChecked: '!bg-veni-green-950 ',

        manageCancelButton: buttonVariants({ variant: 'outline', className: 'hover:!bg-accent' }),
        manageSaveButton: buttonVariants({
          variant: 'outline',
          className: '!bg-veni-green-950 hover:!bg-veni-green-950/80 !text-primary-foreground',
        }),
        privacyPolicyLink: '!underline w-full !text-center text-xs !text-muted-foreground',
      }}
    >
      {children}
    </ReactCookieManager>
  );
};

export default CookieManager;
